import { GET_RULES, CLEAR_RULE } from '../Actions/types';
import initialState from './initial-state';

export default function(state = initialState.rules, action) {
  switch (action.type) {
    
    case GET_RULES:
      return action.payload;

    case CLEAR_RULE:
      return {};

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/rulesReducer.js